import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardHeader, CardBody } from 'reactstrap';
import Loader from '../../../components/common/Loader';

function SalesConsumptionPredictionCard({ predictions, productIcon }) {
    const salesPredictionLoading = useSelector(state => state.salesPrediction.loading);

    return (
        <Card
            className="card-height-100 d-flex align-items-center"
            style={{
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
                marginLeft: "10px",
            }}
        >
            <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">
                    <b>Sales / Consumption Prediction</b>
                </h4>
            </CardHeader>

            {salesPredictionLoading ?
                (<CardBody 
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%", 
                    height: "212px" 
                }}
                 className="w-100">
                    
                    <Loader />
                </CardBody>
                ) :
                (
                    <CardBody className="w-100">
                        <div
                            className="table-responsive table-card h-100"
                            style={{
                                maxHeight: "212px",
                                overflowY: "auto",
                                minHeight: "212px",
                                padding: "15px"
                            }}
                        >
                            <table className="table table-centered align-middle mb-0">
                                <tbody>
                                    {predictions && predictions.length > 0 ? (
                                        predictions.map((prediction, index) => (
                                            <tr key={index}>
                                                <td className="p-1">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-shrink-0 me-2">
                                                            <i className={`ri-${productIcon || 'focus-fill'} fs-18 text-secondary`}></i>
                                                        </div>
                                                        <div>
                                                            <h5 className="fs-14 my-1 fw-medium">
                                                                {prediction.name}
                                                            </h5>
                                                            <span className="text-muted">
                                                                Product
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td>
                                                    <h5 className="fs-14 mb-0 text-end">
                                                        {prediction.probability}%
                                                        <i className="ri-bar-chart-fill text-secondary fs-16 align-middle ms-2"></i>
                                                    </h5>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <CardBody className="w-100">
                                            {
                                                       <div
                                                       className="table-responsive table-card h-100"
                                                       style={{
                                                           minHeight: "355px",
                                                           maxHeight: "355px",
                                                           padding: "15px",
                                                       }}
                                                   >
                                                       <table className="table table-centered align-middle mb-0">
                                                               <tbody>
                                                               <tr>
                                                                           <td colSpan="3" className="text-center">
                                                                               No Data Available
                                                                           </td>
                                                                       </tr>
                                                               </tbody>
                                                               </table>
                                       
                                                       </div>
                                            }
                                        </CardBody>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                )
            }
        </Card>
    );
}


export default SalesConsumptionPredictionCard;
